import * as mainHeader from "./main/index"
import * as subMenu from "./submenu/index"
import * as utils from "../../../_src/components/utils/isMobile"

var DOM = {
    header: document.querySelector(".header"),
    mainHeaderElement: document.querySelector(".main-header"),
    contentLinks: document.querySelector(".main-header__links"),
    mainTag: document.querySelector("main")
}

if (typeof(DOM.mainTag) != null) {
    utils.isMobile()

    const observer = new MutationObserver(callback)

    observer.observe(document.querySelector("body"), {attributes: true})

    function callback(element, observer) {
        if (element[0].target.classList != 0 && window.location.href.includes('faeg')) {
            mainHeader.controls(DOM)
            subMenu.toggleSubMenuSubMenu()
            observer.disconnect();
        }
    }

    if (window.location.pathname == '/' && document.documentElement.clientWidth > 1263 && window.location.href.includes('faeg')) {
        document.body.classList.add("big-green-ball")

        window.onscroll = () => {
            if (window.pageYOffset < 65) {
                DOM.header.classList.add("transparent")
                DOM.header.classList.remove("bg-white", "shadow")
            } else {
                DOM.header.classList.remove("transparent")
                DOM.header.classList.add("bg-white", "shadow")
            }
        }
    } else {
        DOM.header?.classList.add("bg-white", "shadow")
    }
} else {
    console.error("Verifique todos os requisitos para as funções 'hiddenOrShowItens()' e 'controls()'")
}
